var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['round no-print', _vm.$style.button],on:{"click":function($event){return _vm.$store.dispatch('chromeEditor/guideStep', _vm.guideRef)}}},[_c('span',[_vm._v("𐐅")])])}
var staticRenderFns = []

export { render, staticRenderFns }